require("core-js/modules/esnext.global-this.js");

!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t(require("react"), require("prop-types"), require("@leafygreen-ui/emotion")) : "function" == typeof define && define.amd ? define(["react", "prop-types", "@leafygreen-ui/emotion"], t) : ((e = "undefined" != typeof globalThis ? globalThis : e || self).ImportantWithCircle = e.ImportantWithCircle || {}, e.ImportantWithCircle.js = t(e.React, e.PropTypes, e["@leafygreen-ui/emotion"]));
}(this, function (e, t, r) {
  "use strict";

  function l(e) {
    return e && "object" == typeof e && "default" in e ? e : {
      default: e
    };
  }

  function a(e) {
    if (e && e.__esModule) return e;
    var t = Object.create(null);
    return e && Object.keys(e).forEach(function (r) {
      if ("default" !== r) {
        var l = Object.getOwnPropertyDescriptor(e, r);
        Object.defineProperty(t, r, l.get ? l : {
          enumerable: !0,
          get: function get() {
            return e[r];
          }
        });
      }
    }), t.default = e, Object.freeze(t);
  }

  var n = a(e),
      i = l(t);

  function o(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }

  function u() {
    return u = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];

        for (var l in r) {
          Object.prototype.hasOwnProperty.call(r, l) && (e[l] = r[l]);
        }
      }

      return e;
    }, u.apply(this, arguments);
  }

  function c(e, t) {
    if (null == e) return {};

    var r,
        l,
        a = function (e, t) {
      if (null == e) return {};
      var r,
          l,
          a = {},
          n = Object.keys(e);

      for (l = 0; l < n.length; l++) {
        r = n[l], t.indexOf(r) >= 0 || (a[r] = e[r]);
      }

      return a;
    }(e, t);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);

      for (l = 0; l < n.length; l++) {
        r = n[l], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (a[r] = e[r]);
      }
    }

    return a;
  }

  function f(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
      raw: {
        value: Object.freeze(t)
      }
    }));
  }

  var s,
      p,
      b = {
    small: 14,
    default: 16,
    large: 20,
    xlarge: 24
  };

  var d = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"],
      y = function y(e) {
    var t,
        l = e.className,
        a = e.size,
        i = void 0 === a ? 16 : a,
        y = e.title,
        m = e["aria-label"],
        g = e["aria-labelledby"],
        h = e.fill,
        O = e.role,
        v = void 0 === O ? "img" : O,
        j = c(e, d),
        C = r.css(s || (s = f(["\n    color: ", ";\n  "])), h),
        w = r.css(p || (p = f(["\n    flex-shrink: 0;\n  "]))),
        x = function (e, t, r) {
      var l,
          a,
          n = r["aria-label"],
          i = r["aria-labelledby"],
          u = r.title;

      switch (e) {
        case "img":
          return n || i || u ? (o(l = {}, "aria-labelledby", i), o(l, "aria-label", n), o(l, "title", u), l) : {
            "aria-label": (a = t, "".concat(a.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon"))
          };

        case "presentation":
          return {
            "aria-hidden": !0,
            alt: ""
          };
      }
    }(v, "ImportantWithCircle", (o(t = {
      title: y
    }, "aria-label", m), o(t, "aria-labelledby", g), t));

    return n.createElement("svg", u({
      className: r.cx(o({}, C, null != h), w, l),
      height: "number" == typeof i ? i : b[i],
      width: "number" == typeof i ? i : b[i],
      role: v
    }, x, j, {
      viewBox: "0 0 16 16"
    }), n.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM7 4.5C7 3.94772 7.44772 3.5 8 3.5C8.55228 3.5 9 3.94772 9 4.5V8.5C9 9.05228 8.55228 9.5 8 9.5C7.44772 9.5 7 9.05228 7 8.5V4.5ZM9 11.5C9 12.0523 8.55228 12.5 8 12.5C7.44772 12.5 7 12.0523 7 11.5C7 10.9477 7.44772 10.5 8 10.5C8.55228 10.5 9 10.9477 9 11.5Z",
      fill: "currentColor"
    }));
  };

  return y.displayName = "ImportantWithCircle", y.isGlyph = !0, y.propTypes = {
    fill: i.default.string,
    size: i.default.oneOfType([i.default.number, i.default.string]),
    className: i.default.string
  }, y;
});